import { useState, useEffect } from 'react';

export default function Hero() {
  const [showVideo, setShowVideo] = useState(false);

  useEffect(() => {
    if (showVideo) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => { document.body.style.overflow = ''; };
  }, [showVideo]);

  return (
    <section className="relative min-h-screen bg-gradient-to-b from-black to-[#0a0a0a] flex items-center overflow-hidden">
      {/* Background decorative elements */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-20 left-10 w-96 h-96 bg-[#D4AF37] rounded-full blur-[120px]"></div>
        <div className="absolute bottom-20 right-10 w-96 h-96 bg-[#D4AF37] rounded-full blur-[120px]"></div>
      </div>

      <div className="max-w-7xl mx-auto px-6 py-32 grid lg:grid-cols-2 gap-12 items-center relative z-10">
        {/* Left Content */}
        <div className="space-y-8">
          <h1 className="text-4xl lg:text-5xl font-serif font-bold leading-tight">
            Viva uma
            <br />
            <span className="text-[#D4AF37]">Experiência Inesquecível</span>
            <br />
            em Nova York com <span className="text-[#D4AF37]">PremierNY</span>
          </h1>

          <p className="text-xl lg:text-2xl text-white/85 font-light leading-relaxed">
            Viagens personalizadas e sem estresse,
            <br />
            criadas exclusivamente para brasileiros
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 pt-6">
            <a 
              href="#packages"
              className="px-6 py-3 bg-[#D4AF37] text-black font-bold text-base rounded-full hover:bg-[#C5A028] transition-all duration-300 shadow-lg hover:shadow-[#D4AF37]/50 text-center whitespace-nowrap"
            >
              Receba meu itinerário personalizado
            </a>
            <a 
              href="https://wa.me/16466330270" 
              target="_blank" 
              rel="noopener noreferrer"
              className="px-6 py-3 border-2 border-white text-white font-bold text-base rounded-full hover:bg-white hover:text-black transition-all duration-300 flex items-center justify-center gap-2 whitespace-nowrap"
            >
              <i className="ri-whatsapp-line text-xl"></i>
              Converse pelo WhatsApp
            </a>
          </div>
        </div>

        {/* Right Video Section */}
        <div className="relative">
          <div className="relative rounded-[32px] overflow-hidden border-2 border-[#D4AF37] shadow-2xl">
            {/* Video Container */}
            <div className="relative aspect-[9/16] lg:aspect-video bg-black">
              <img 
                src="https://public.readdy.ai/ai/img_res/449b8fa40b8b22ad86b5496f7caa55fe.jpg"
                alt="New York Experience"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/20 to-transparent"></div>
              
              {/* Video Caption Overlay */}
              <div className="absolute bottom-8 right-8 bg-black/70 backdrop-blur-sm px-6 py-4 rounded-full">
                <p className="text-white font-serif text-lg italic leading-tight">
                  Conheça Nova York
                  <br />
                  <span className="text-[#D4AF37]">Como Nunca Antes</span>
                </p>
              </div>

              {/* Play Button Overlay */}
              <div className="absolute inset-0 flex items-center justify-center">
                <button 
                  onClick={() => setShowVideo(true)}
                  className="w-20 h-20 bg-[#D4AF37]/90 rounded-full flex items-center justify-center hover:bg-[#D4AF37] transition-all duration-300 hover:scale-110 cursor-pointer"
                >
                  <i className="ri-play-fill text-4xl text-black ml-1"></i>
                </button>
              </div>
            </div>
          </div>

          {/* Decorative corner elements */}
          <div className="absolute -top-4 -left-4 w-24 h-24 border-t-4 border-l-4 border-[#D4AF37] rounded-tl-3xl"></div>
          <div className="absolute -bottom-4 -right-4 w-24 h-24 border-b-4 border-r-4 border-[#D4AF37] rounded-br-3xl"></div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-10 left-1/2 transform -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-3xl text-[#D4AF37]"></i>
      </div>

      {/* Video Modal */}
      {showVideo && (
        <div 
          className="fixed inset-0 z-50 flex items-center justify-center bg-black/70 backdrop-blur-sm"
          onClick={() => setShowVideo(false)}
        >
          <button
            onClick={() => setShowVideo(false)}
            className="absolute top-6 right-6 w-10 h-10 flex items-center justify-center rounded-full bg-white/10 hover:bg-white/20 transition-colors cursor-pointer"
          >
            <i className="ri-close-line text-2xl text-white"></i>
          </button>
          <div 
            className="w-full max-w-2xl mx-6 aspect-video rounded-2xl overflow-hidden border-2 border-[#D4AF37]/40 shadow-2xl"
            onClick={(e) => e.stopPropagation()}
          >
            <iframe
              className="w-full h-full"
              src="https://www.youtube.com/embed/l3xyuf3Y00w?autoplay=1&rel=0"
              title="New York City Experience - PremierNY"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            ></iframe>
          </div>
        </div>
      )}
    </section>
  );
}